import { render } from "./ProcessMonitoring.vue?vue&type=template&id=f8a2fd4a&scoped=true"
import script from "./ProcessMonitoring.vue?vue&type=script&lang=js"
export * from "./ProcessMonitoring.vue?vue&type=script&lang=js"

import "./ProcessMonitoring.vue?vue&type=style&index=0&id=f8a2fd4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8a2fd4a"]])

export default __exports__